__webpack_require__.p = "https://student-matching-dashboard.studyportals.eu/dist/";